@if (contentlet$ | async; as contentlet) { @if (deviceType$ | async; as deviceType) { @if (dotcmsHost$ | async; as
dotcmsHost) {
<div [class]="'container-' + contentlet.identifier">
  <div
    style="position: relative"
    [id]="'image-container-' + contentlet.identifier"
    [ngClass]="{ 'tooltip-max-width': contentlet.maxWidth.length > 0, 'w-100': !(contentlet.maxWidth.length > 0) }"
    class="tooltip-image-container"
  >
    <img
      [id]="'image-' + contentlet.identifier"
      loading="lazy"
      style="width: 100%"
      [src]="getImageSrc(deviceType) | async"
      [attr.alt]="contentlet.alternateText || contentlet.title"
    />
    @if (!productFailed) { @for (product of tooltipDetails; track product) { @if (getDisplayStyle(deviceType, product))
    {
    <div
      class="product-pointers"
      [style.top]="getTopPosition(deviceType, product)"
      [style.left]="getLeftPosition(deviceType, product)"
      (click)="showPopup(deviceType, product.sku)"
      (keydown)="showPopup(deviceType, product.sku)"
    >
      @if (deviceType === 'desktop') {
      <div class="product-popup" [ngClass]="'popup-' + product.position">
        <custom-dot-cms-product-item
          (isProductFailedEvent)="onProductFailed($event)"
          ishProductContext
          [sku]="product.sku"
          [configuration]="{ addToBasket: true, image: true, name: true, price: true }"
          [layout]="'tooltip'"
          [productElementUniqueId]="contentlet.identifier + '-product-popup-' + product.sku"
        />
      </div>
      }
      <span class="product-pointers-point"></span>
      <span class="product-hotspot-two"></span>
      <span class="product-hotspot"></span>
    </div>
    } @if (deviceType !== 'desktop') {
    <div
      class="product-popup"
      [ngClass]="contentlet.identifier + '-product-popup-' + product.sku"
      [id]="contentlet.identifier + '-product-popup-' + product.sku"
    >
      <custom-dot-cms-product-item
        (isProductFailedEvent)="onProductFailed($event)"
        ishProductContext
        [sku]="product.sku"
        [configuration]="{ addToBasket: true, image: true, name: true, price: true }"
        [layout]="'tooltip'"
        [productElementUniqueId]="contentlet.identifier + '-product-popup-' + product.sku"
      />
    </div>
    } } }
  </div>
</div>
} } }
